import Request from 'src/utils/request'

/**
 * 查询人员列表
 */
export function getPersonnelListApi (params) {
  return Request({
    url: '/accounts',
    params,
  })
}

/**
 * 删除人员
 */
export function delPersonnelApi (id) {
  return Request({
    url: `/accounts/${id}`,
    method: 'delete',
  })
}

/**
 * 重置人员登录密码
 */
export function resetPersonnelPWDApi (id) {
  return Request({
    url: `/accounts/${id}/reset_password`,
    method: 'post',
  })
}

/**
 * 设置人员为管理员
 */
export function setPersonnelManagerApi (id) {
  return Request({
    url: `/accounts/${id}/manager`,
    method: 'post',
  })
}

/**
 * 获取人员信息详情
 */
export function getPersonnelDetailApi (id) {
  return Request({
    url: `/accounts/${id}`,
    method: 'get',
  })
}

/**
 * 保存人员信息
 */
export function editPersonnelApi (data) {
  return Request({
    url: '/accounts',
    method: 'post',
    data,
  })
}
